import Core       from "@/core/Core";
import ReportsDAO from "./ReportsDAO";

/**
 * Сервис для работы с отчётами
 * Оркестрирует выгрузку: запрос → проверка ответа → скачивание файла
 */
class ReportsService {

	/**
	 * Возвращает список всех доступных отчётов для отображения в UI
	 */
	static reportsList() {
		return [
			{ title: 'Реестр сделок',                  rpcMethod: 'reports.getDealsReport' },
			{ title: 'Скачать отчет по потребностям',  rpcMethod: 'reports.getNamanganDemandsReport' },
			{ title: 'По потребностям',                rpcMethod: 'reports.getDemandsReport' },
			{ title: 'По транспорту',                  rpcMethod: 'reports.getTransportReport' },
			{ title: 'По CRM',                         rpcMethod: 'reports.getPartnersReport' },
			{ title: 'По платежам',                    rpcMethod: 'reports.getPaymentsReport' },
			{ title: 'Об изменении цен',               rpcMethod: 'reports.getPriceReport' },
			{ title: 'По тендерам',                    rpcMethod: 'reports.getTendersReport' },
			{ title: 'По товарам',                     rpcMethod: 'reports.getNomenclatureReport' },
			{ title: 'Своевременность поставок',       rpcMethod: 'reports.getShipmentDelayReport' },
		];
	}

	/**
	 * Скачивает отчёт по указанному RPC-методу
	 * Ошибки запроса обрабатываются в RpcService (тост + Sentry)
	 */
	static async download(rpcMethod: string): Promise<boolean> {
		const response = await ReportsDAO.getReport(rpcMethod);

		const file = response.data?.file;

		if (!file || typeof file.data !== 'string' || file.data.length === 0) {
			return false;
		}

		Core.utils.file.downloadFromBase64(file.data, file.name, file.mimeType);
		return true;
	}
}

export default ReportsService;
